import { render, staticRenderFns } from "./ModalDetalleCandidato.vue?vue&type=template&id=b68a1298&scoped=true"
import script from "./ModalDetalleCandidato.vue?vue&type=script&lang=js"
export * from "./ModalDetalleCandidato.vue?vue&type=script&lang=js"
import style0 from "./ModalDetalleCandidato.vue?vue&type=style&index=0&id=b68a1298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68a1298",
  null
  
)

export default component.exports